import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { MessagingModel } from '../model/messaging.model';
import { MessagingModalComponent } from '../messaging-modal.component';

@Injectable()
export class MessagingService {
  bsModalRef: BsModalRef;

  constructor(private modalService: BsModalService) {}

  private prepareObject(object): void {
    for (const i in object) {
      if (object[i] === undefined) {
        delete object[i];
      }
    }
  }

  error(
    title,
    message,
    acceptBtnName?,
    acceptFunction?,
    closeBtnName?,
    closeFunction?,
    modalParentClass?
  ): void {
    const initialState: MessagingModel = {
      title,
      content: message,
      infoMessage: false,
      closeBtnName,
      closeFunction,
      acceptBtnName,
      acceptFunction,
    };
    modalParentClass = modalParentClass ? modalParentClass : '';
    modalParentClass += ' error-modal';
    this.prepareObject(initialState);
    this.bsModalRef = this.modalService.show(MessagingModalComponent, {
      class: modalParentClass,
      initialState,
    });
  }

  info(
    title,
    message,
    secondmessage: boolean,
    acceptBtnName?,
    acceptFunction?,
    closeBtnName?,
    closeFunction?,
    modalParentClass?
  ): void {
    const initialState: MessagingModel = {
      title,
      content: message,
      infoMessage: secondmessage,
      closeBtnName,
      closeFunction,
      acceptBtnName,
      acceptFunction,
    };
    modalParentClass = modalParentClass ? modalParentClass : '';
    modalParentClass += '';
    modalParentClass += ' modal-dialog-centered';
    this.prepareObject(initialState);
    this.bsModalRef = this.modalService.show(MessagingModalComponent, {
      class: modalParentClass,
      initialState,
    });
  }

  warning(
    title,
    message,
    acceptBtnName?,
    acceptFunction?,
    closeBtnName?,
    closeFunction?,
    modalParentClass?
  ): void {
    const initialState: MessagingModel = {
      title,
      content: message,
      infoMessage: false,
      closeBtnName,
      closeFunction,
      acceptBtnName,
      acceptFunction,
    };
    modalParentClass = modalParentClass ? modalParentClass : '';
    modalParentClass += ' warning-modal';
    this.prepareObject(initialState);
    this.bsModalRef = this.modalService.show(MessagingModalComponent, {
      class: modalParentClass,
      initialState,
    });
  }
}
